(ns nl.mediquest.ui.core.footer
  (:require
   [clojure.spec.alpha :as s]
   [clojure.string :as string]
   [integrant.core :as ig]))

(defn- get-current-year []
  (.getFullYear (js/Date.)))

(defn- substitute-variables [text]
  (string/replace text "{{CURRENT_YEAR}}" (get-current-year)))

(defn footer [{:footer/keys [logo privacy-link copyright version]}]
  [:div.min-h-16.py-5.bg-footer.text-white.flex-shrink-0.print:hidden
   [:div.container.mx-auto
    [:div.h-full.flex-wrap.flex.justify-between.content-center.text-center
     [:div.w-full.md:w-auto.flex
      [:img.inline-block.h-8.ml-4 {:src logo}]
      (when version
        [:div.text-center version])]
     [:div.text-center.w-full.md:w-auto.pt-1
      [:a.block.md:inline-block
       {:href privacy-link
        :target :_blank}
       "Privacy Statement"]
      [:div.block.md:inline-block.px-4 (substitute-variables copyright)]]]]])

(s/def :footer/logo string?)
(s/def :footer/privacy-link string?)
(s/def :footer/copyright string?)
(s/def :footer/version string?)

(defmethod ig/assert-key :component.ui/footer [_k v]
  (assert (s/valid? (s/keys :req [:footer/logo
                                   :footer/privacy-link
                                   :footer/copyright]
                             :opt [:footer/version])
                     v)))

(defmethod ig/init-key :component.ui/footer
  [_ opts]
  (fn []
    [footer opts]))
